export default "__VITE_ASSET__1e08fc72__"